module.exports = __webpack_public_path__ + "img/icon-personajes.166868a7.svg";